module.exports = __webpack_public_path__ + "static/media/member nalas-06.35b4ebae.png";